export const API_URL = process.env.REACT_APP_API_URL || 'https://urinetest.pythonanywhere.com';
export const API_KEY = process.env.REACT_APP_API_KEY || 'your-api-key-here';
